import { ref, nextTick } from 'vue';

export const useSchedulePopover = (options = {}) => {
	const { proxyRef = null } = options;

	const showPopover = ref(false);
	const referenceNode = ref();
	const popoverRef = ref();
	const currScheduleContent = ref({});

	const getPopoverRef = () => {
		if (proxyRef) {
			return proxyRef(popoverRef.value);
		}
		return popoverRef.value;
	};

	const popoverPosRef = ref({});
	const addPopoverPosRef = (node, id) => {
		popoverPosRef.value[id] = node;
	};
	const clearPopoverPosRef = () => {
		popoverPosRef.value = {};
	};

	const handleShowPopover = (uuid, content) => {
		showPopover.value = false;
		referenceNode.value = popoverPosRef.value[uuid].$el;
		nextTick(() => {
			currScheduleContent.value = { ...content };
			showPopover.value = true;
			nextTick(() => {
				const contentRef = getPopoverRef();
				contentRef && contentRef.doShow();
			});
		});
	};
	const handleClosePopover = () => {
		const contentRef = getPopoverRef();
		contentRef && contentRef.doClose();
	};

	return {
		showPopover,
		referenceNode,
		popoverRef,
		currScheduleContent,
		addPopoverPosRef,
		clearPopoverPosRef,
		handleShowPopover,
		handleClosePopover
	};
};
